import script from "./SpecificationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SpecificationModal.vue?vue&type=script&setup=true&lang=js"

import "./SpecificationModal.vue?vue&type=style&index=0&id=5db83290&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5db83290"]])

export default __exports__